import { colors } from "../variables";
export const styles = {
  wrapper: {
    backgroundColor: colors.grayBackground,
    borderRadius: 4,
    boxModel: "border-box",
  },
  Input: {
    background: colors.grayBackgroundGradient,
    width: "100%",
  },
};
